import { Profile } from '@/types';
import { isDev } from '@/utils/enviroment';

import { CUSTOM_EVENTS_LIST, events } from './types';

declare var braze: any;

export const init = () => {
  if (!process.env.NEXT_PUBLIC_BRAZE_API_KEY || !process.env.NEXT_PUBLIC_BRAZE_ENDPOINT) {
    console.warn('Please include the Braze API Key & End-pt');
    return;
  }

  braze.initialize(process.env.NEXT_PUBLIC_BRAZE_API_KEY, {
    baseUrl: process.env.NEXT_PUBLIC_BRAZE_ENDPOINT,
    enableLogging: isDev,
    disablePushTokenMaintenance: true,
    manageServiceWorkerExternally: true,
  });

  braze.openSession();
};

export const changeUser = (profile: Profile) => {
  braze.changeUser(profile.accountId);
};

export const logEvent = (event: events, attrs: any) => {
  braze.logCustomEvent(CUSTOM_EVENTS_LIST[event], attrs);
};
